export const APP_VERSION = 'v0.1.4';
export const DEVELOPER = '阿潘';

export const BIOCLOCK_STORE_KEY = 'BIOCLOCK_STORE_KEY';

export const INIT_ECHARTS_OPTS = {
  title: {
    text: '',
  },
  tooltip: {
    trigger: 'axis',
  },
  legend: {
    top: 'top',
    data: ['体力', '情绪', '智力'],
  },
  grid: {
    left: '2%',
    right: '2%',
    bottom: '15%',
    containLabel: true,
    show: true,
  },
  toolbox: {
    feature: {
      saveAsImage: {},
    },
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    axisPointer: {
      value: '2020-5-2',
      snap: true,
      lineStyle: {
        color: '#004E52',
        opacity: 0.5,
        width: 2,
      },
      label: {
        show: true,
        formatter: function (params) {
          return params.value;
        },
        backgroundColor: '#004E52',
      },
      handle: {
        show: true,
        color: '#004E52',
      },
    },
    data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
  },
  yAxis: {
    type: 'value',
  },
  series: [
    {
        name: '体力',
        type: 'line',
        data: [150, 232, 201, 154, 190, 330, 410],
      },
    {
      name: '情绪',
      type: 'line',
      data: [120, 132, 101, 134, 90, 230, 210],
    },
    {
      name: '智力',
      type: 'line',
      data: [220, 182, 191, 234, 290, 330, 310],
    },
  ],
};

// 曲线的一半天数
export const INTERVAL_DAY = 15;

// 体力周期
export const PHYSIC_CYCLE = 23;

// 智力周期
export const EMOTION_CYCLE = 28;

// 情绪周期
export const INTELLECTUAL_CYCLE = 33;
